import { ErrorPageComponent } from '@/webapp/src/components/errors/ErrorPageComponent/index.js'

export const NotFoundPageComponent = (props: { title?: string; message?: string }) => {
  const title = props.title || 'Страница не найдена'
  const message = props.message || 'Посетите другую страницу, пожалуйста'
  return <ErrorPageComponent title={title} message={message} />
}
